// src/app/modules/common/components/ConfirmActionModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import { X, AlertTriangle, UserX, Trash2, CheckCircle } from 'lucide-react';
import './ConfirmActionModal.scss';

export function ConfirmActionModal({ 
  show, 
  onHide, 
  onConfirm, 
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "danger", // danger, warning, success, info
  loading = false,
  icon = null,
}) {
  const typeConfig = {
    danger: {
      icon: Trash2,
      iconColor: 'text-danger',
      iconBg: 'bg-danger-light',
      btnClass: 'btn-danger',
    },
    warning: {
      icon: UserX,
      iconColor: 'text-warning',
      iconBg: 'bg-warning-light',
      btnClass: 'btn-warning',
    },
    success: {
      icon: CheckCircle,
      iconColor: 'text-success',
      iconBg: 'bg-success-light',
      btnClass: 'btn-success',
    },
    info: {
      icon: AlertTriangle,
      iconColor: 'text-info',
      iconBg: 'bg-info-light',
      btnClass: 'btn-info',
    },
  };

  const config = typeConfig[type] || typeConfig.danger;
  const IconComponent = icon || config.icon;

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="md"
      className="confirm-action-modal"
    >
      <div className="confirm-modal-content">
        <div className="modal-header-custom">
          <h3>{title}</h3>
          <button className="btn-close-custom" onClick={onHide} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-body-custom">
          <div className={`icon-wrapper ${config.iconBg}`}>
            <IconComponent size={48} className={config.iconColor} />
          </div>

          <div className="message-content">
            {typeof message === 'string' ? (
              <p>{message}</p>
            ) : (
              message
            )}
          </div>
        </div>

        <div className="modal-footer-custom">
          <button 
            type="button" 
            className="btn btn-light" 
            onClick={onHide}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            type="button" 
            className={`btn ${config.btnClass}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" />
                Processing...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
}